const navbarMenu = document.getElementById("menu");
const menuSecondary = document.getElementById('menu-secondary');
const burgerMenu = document.getElementById("burger");
const bgOverlay = document.getElementById("overlay");

// Show Menu when Click the Burger
// Hide Menu when Click the Overlay
if (burgerMenu && navbarMenu && bgOverlay) {
    burgerMenu.addEventListener("click", () => {
        navbarMenu.classList.toggle("is-active");
        menuSecondary.classList.toggle("is-active");
        bgOverlay.classList.toggle("is-active");
    });

    bgOverlay.addEventListener("click", () => {
        navbarMenu.classList.toggle("is-active");
        menuSecondary.classList.toggle("is-active");
        bgOverlay.classList.toggle("is-active");
    });
}

// Hide Menu when Click the Links
document.querySelectorAll(".menu-link").forEach((link) => {
    link.addEventListener("click", () => {
        navbarMenu.classList.remove("is-active");
        menuSecondary.classList.remove("is-active");
        bgOverlay.classList.remove("is-active");
        subMenu.classList.remove("is-active");
    });
});

// Animate burger icon
document.getElementById('burger').addEventListener('click', function() {
    this.classList.toggle('is-open');
});

// Responsive submenu toggle (mobile only)
(function($) {
    class ResponsiveMenu {
        constructor() {
            this.initiateMenu();
        }

        initiateMenu() {
            var $body = $("body");

            if ($(window).width() < 1024) {
                $body.on('click', '.menu-item-has-children > a', function(e) {
                    e.preventDefault();
                });

                $body.on('click', '.menu-item-has-children', function(e) {
                    e.stopPropagation();

                    var $this = $(this);
                    var $subMenu = $this.find('.sub-menu-wrap-0');
                    // Uncomment : If you want to hide submenu of an other element of menu

                    $body.find('.menu-item-has-children').not($this).each(function () {
                        $(this).removeClass('is-active');
                        $(this).find('.sub-menu-wrap-0').removeClass('open');
                    });

                    // Toggle du courant
                    if ($subMenu.hasClass('open')) {
                        $subMenu.removeClass('open');
                        $this.removeClass('is-active');
                    } else {
                        $subMenu.addClass('open');
                        $this.addClass('is-active');
                    }
                });            }
        }
    }

    new ResponsiveMenu();
})(jQuery);

// Shrink header on scroll (desktop)
$(document).ready(function () {
    if (window.matchMedia("(min-width: 1024px)").matches) {
        $(window).scroll(function () {
            $("#mainHeader").toggleClass("block-header-shrink", $(this).scrollTop() > 100);
        });
    }
});

// Active parent menu item on child page
window.addEventListener('DOMContentLoaded', () => {
    const elsSousservice = document.querySelectorAll('.menu-parent');
    elsSousservice.forEach(sousservice => {
        sousservice.addEventListener('click', () => {
            const sousServiceChildList = sousservice.querySelector('.menu-parent .menu');

            if (sousServiceChildList.classList.contains('active')) {
                sousServiceChildList.classList.remove('active');
                sousservice.classList.remove('active');
            } else {
                if (document.querySelector('.row .menu.active')) {
                    document.querySelector('.row .menu.active').classList.remove('active');
                    document.querySelector('.menu-parent.active').classList.remove('active');
                }
                sousServiceChildList.classList.add('active');
                sousservice.classList.add('active');
            }
        });
    });
});